import {createContext } from 'react'
const GameContext = createContext();

export default GameContext;